import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from "./Reducers/FacetedSearch.reducer";
import { myPage } from './Reducers/MyPage.reducer';
import { checkout } from "./Reducers/Checkout.reducer";
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { notification } from './Reducers/Notification.reducer';
import { addToCartPopup } from './Reducers/AddToCartPopup.reducer';
import { contractorSearch } from './Reducers/ContractorSearch.reducer';
import { quotation } from './Reducers/Quotation.reducer';
import { buyButton } from './Reducers/BuyButton.reducer';
import { productConfigurator } from './Reducers/ProductConfigurator.reducer';
import { quantityCalculator } from './Reducers/QuantityCalculator.reducer';

const app = combineReducers({
    cart,
    checkout,
    quickSearch,
    navigation,
    myPage,
    facetedSearch,
    lightboxImages,
    notification,
    addToCartPopup,
    contractorSearch,
    quotation,
    buyButton,
    productConfigurator,
    quantityCalculator
});

export default app;
